// extracted by mini-css-extract-plugin
export default {"contentWrapper":"addTemplate_contentWrapper__EOsZE"};